import style from './acx.module.scss';
import cls from 'classnames';
import facebbokSvg from '../../../assets/svg/facebook.svg';
import igSvg from '../../../assets/svg/ig.svg';
import { useIntl } from 'react-intl';
import { showAgreement as showAgreementDrawer } from '@/components/Drawer';

const ICIRENAFooter = (props) => {
  const intl = useIntl();
  const { protocolList } = props;

  return (
    <div className={cls('h5-none pad-none', style.ACXFooter, style.ICIRENAFooter)}>
      <div className={style.footer_box}>
        <div className={style.footer_address}>
          <div className={style.footer_item}>
            <div className={style.footer_tab}>{intl.formatMessage({ id: 'iWeb.components.Footer.FollowUs', defaultMessage: '关注我们' })}</div>
            <div className={cls(style.footer_tab_content, style.address_warrper)}>
              <div className={style.other}>
                <a href="https://www.facebook.com/bonacinemamacau/" target="_blank"><img src={facebbokSvg} alt="" className={style.other_img} /></a>
                <a href="https://www.instagram.com/bonacinemamacau/" target="_blank"><img src={igSvg} alt="" className={style.other_img} /></a>
              </div>
              <div className={style.icirena_info}>
                <div className={style.icirena_info_left}>
                  <div className={style.address_flex}>
                    <span className={style.flex_left}>
                      <span className={style.address_icon} />
                    </span>
                    <span className={style.address}>{intl.formatMessage({ id: 'iWeb.components.Footer.ICIRENAAddress', defaultMessage: '澳门湖滨路12号YOHO金银岛名胜世界酒店一楼博纳国际影城' })}</span>
                  </div>
                  <div className={cls(style.address_flex, style.time)}>
                    <span className={style.flex_left}>
                      <span className={style.time_icon} />
                    </span>
                    <div className={style.opening_hours}>
                      <p>{intl.formatMessage({ id: 'iWeb.components.Footer.BusinessHours', defaultMessage: '营业时间' })}:</p>
                      {/* <p>{intl.formatMessage({ id: 'iWeb.components.Footer.BusinessTime', defaultMessage: '平日12:30-00:00，周末9:30-00:00' })}</p> */}
                      <p>10:00-00:00</p>
                    </div>
                  </div>
                </div>
                <div className={style.icirena_info_right}>
                  <div className={style.address_flex}>
                    <span className={style.flex_left}>
                      <span className={style.phone_icon} />
                    </span>
                    <div className={style.tell_phone}>
                      <p>{intl.formatMessage({ id: 'iWeb.components.Footer.ICIRENAPhone', defaultMessage: '一般查询专线' })}:  (+853) 2848 3888</p>
                      <p>{intl.formatMessage({ id: 'iWeb.components.Footer.ICIRENAAdvartPhone', defaultMessage: '包场活动/广告位查询' })}: (+853) 6555 2882</p>
                      <p>({intl.formatMessage({ id: 'iWeb.components.Footer.ICIRENAAdvartPrompt', defaultMessage: '包场活动/广告位查询服务时间： 星期一至五，早上十时至下午六时，公众假期除外' })})</p>
                    </div>
                  </div>
                </div>
              </div>
              {
                protocolList?.length > 0 &&
                <div className={cls(style.address_flex, style.align_center, style.protocol)}>
                  {protocolList?.map((item, index) => {
                    return (
                      <span
                        onClick={() => {
                          showAgreementDrawer({
                            detail: item,
                          });
                        }}
                        key={index}
                        className={style.protocol_name}
                      >《{item?.title}》</span>
                    );
                  })}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ICIRENAFooter;